import React from "react";
import PostLosLockModal from "./post-los-lock-modal/PostLosLockModal";
import TranslationErrorModal from "./translation-error-modal/TranslationErrorModal";
import LanguageToggle from "./language-toggle/LanguageToggle";
import EnglishRevertModal from "./english-revert-modal/EnglishRevertModal";
import SpanishAcknowledgmentModal from "components/v2/spanish-acknowledgment-modal/SpanishAcknowledgmentModal";
import { LoadingOverlay } from "components/ui/loading-spinners";
import { SUPPORTED_LANGUAGES, TRANSLATION_ERROR_LABEL } from "utilities/Constant";
import { usePreferredLanguage } from "./usePreferredLanguage";

interface PreferredLanguageProps {
  readonly isMobile?: boolean;
  readonly isAuthenticated?: boolean;
}

const PreferredLanguage: React.FC<PreferredLanguageProps> = ({ isMobile = false, isAuthenticated = false }) => {
  const {
    isPreferredLanguageEnabled,
    userLanguage,
    isPostLosLoanContext,
    isTranslationFailed,
    isPersistingPreferredLanguage,
    showPostLosLockModal,
    showTranslationErrorModal,
    showEnglishRevertModal,
    showAcknowledgmentModal,
    learnMoreButtonRef,
    translationLearnMoreButtonRef,
    handleLanguageChange,
    handleAcknowledge,
    handleAcknowledgmentCancel,
    handleRevertConfirm,
    handleRevertCancel,
    handleClosePostLosLockModal,
    setShowPostLosLockModal,
    setShowTranslationErrorModal,
    getLockedClickHandler,
  } = usePreferredLanguage({ isMobile, isAuthenticated });

  if (!isPreferredLanguageEnabled) {
    return null;
  }

  return (
    <>
      <div className="preferred-language">
        {isTranslationFailed && !isMobile && (
          <div className="preferred-language__error-details">
            <span className="preferred-language__error-label GlobalLinkNoTx">{TRANSLATION_ERROR_LABEL}</span>
            <button
              ref={translationLearnMoreButtonRef}
              type="button"
              className="preferred-language__learn-more-button"
              onClick={() => setShowTranslationErrorModal(true)}
            >
              Learn More
            </button>
          </div>
        )}
        {isPostLosLoanContext && !isTranslationFailed && !isMobile && (
          <div className="preferred-language__lock-details">
            <span className="preferred-language__lock-label">Language Locked</span>
            <button
              ref={learnMoreButtonRef}
              type="button"
              className="preferred-language__learn-more-button"
              onClick={() => setShowPostLosLockModal(true)}
            >
              Learn More
            </button>
          </div>
        )}
        <LanguageToggle
          value={userLanguage}
          onChange={handleLanguageChange}
          options={SUPPORTED_LANGUAGES}
          isMobile={isMobile}
          disabled={isPostLosLoanContext || isPersistingPreferredLanguage}
          showTranslationError={isTranslationFailed}
          onLockedClick={getLockedClickHandler()}
        />
      </div>
      {isAuthenticated && isPersistingPreferredLanguage && (
        <LoadingOverlay text="Updating your language preference..." />
      )}
      {showAcknowledgmentModal && (
        <SpanishAcknowledgmentModal
          onAcknowledge={handleAcknowledge}
          onCancel={handleAcknowledgmentCancel}
        />
      )}
      {showEnglishRevertModal && (
        <EnglishRevertModal onConfirm={handleRevertConfirm} onCancel={handleRevertCancel} />
      )}
      {showPostLosLockModal && (
        <PostLosLockModal onClose={handleClosePostLosLockModal} returnFocusRef={learnMoreButtonRef} />
      )}
      {showTranslationErrorModal && (
        <TranslationErrorModal
          onClose={() => setShowTranslationErrorModal(false)}
          returnFocusRef={translationLearnMoreButtonRef}
        />
      )}
    </>
  );
};

export default PreferredLanguage;
